<template>
  <div class="footer">
    <div class="contents">
      <p>
        <span>©2017-2019 河北省环境应急与重污染天气预警中心</span>
        <span style="margin: 0 20px">|</span>
        <span>技术支持：标旗（武汉）信息技术有限公司</span>
        <span style="margin: 0 20px">|</span>
        <span>版本号：{{version}}</span>
      </p>
      <p style="margin-top: 20px;">
        <span>主要研发人员：孟宪栋、许政、付贺鹏 </span>
      </p>
    </div>
  </div>
</template>
<script>
import other from '../../data/basic/others/other'
export default {
  data() {
    return {
      version: 'v1.0.0'
    }
  },
  created() {
    this.getVersion()
  },
  methods: {
    getVersion() {
      (async () => {
        try {
          let state = await other.version()
          this.version = state
        } catch (error) {
          this.$message.error('获取当前版本号失败')
        }
      })()
    }
  }
}
</script>
<style lang="stylus" scoped>
.footer {
  position: absolute;
  bottom: 20px;
  width: 100%;
  .contents {
    text-align: center;
    margin: 0 auto;
    p {
      font-size: 12px;
      color: #666666;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Footer.vue?135080e8